import type { PaletteMode } from "@mui/material";

export const themeConfig = (prefersDarkMode: Boolean | undefined) => {
  const razorbackRed = "#9D2235";
  const deepBlue = prefersDarkMode ? "#3949ab" : "#283593";
  const softGray = prefersDarkMode ? "#424242" : "#f5f5f5";
  const paperBg = prefersDarkMode ? "#212121" : "#fff";
  return {
    palette: {
      mode: (prefersDarkMode ? "dark" : "light") as PaletteMode,
      primary: {
        main: deepBlue,
        contrastText: "#fff",
      },
      secondary: {
        main: softGray,
        contrastText: prefersDarkMode ? "#fff" : "#000",
      },
      accent: {
        main: razorbackRed,
        contrastText: "#fff",
      },
      background: {
        default: softGray,
        paper: paperBg,
      },
    },
    typography: {
      fontFamily: [
        "Roboto",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif",
      ].join(","),
      h1: { fontWeight: 700 },
      h2: { fontWeight: 600 },
      h5: { fontWeight: 500 },
    },
    shape: {
      borderRadius: 12,
    },
  };
};
